var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7868_1932)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 20,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 5C25.9782 5 29.7936 6.58035 32.6066 9.3934C35.4196 12.2064 37 16.0218 37 20C37 23.9782 35.4196 27.7936 32.6066 30.6066C29.7936 33.4196 25.9782 35 22 35C18.0218 35 14.2064 33.4196 11.3934 30.6066C8.58035 27.7936 7 23.9782 7 20C7 16.0218 8.58035 12.2064 11.3934 9.3934C14.2064 6.58035 18.0218 5 22 5ZM22 11.4286C21.7279 11.4283 21.4588 11.4848 21.2098 11.5945C20.9608 11.7041 20.7375 11.8645 20.5539 12.0653C20.3704 12.2662 20.2308 12.5031 20.1441 12.761C20.0573 13.0188 20.0253 13.2919 20.05 13.5629L20.8321 22.1471C20.8625 22.4357 20.9986 22.7029 21.2142 22.8971C21.4299 23.0913 21.7098 23.1987 22 23.1987C22.2902 23.1987 22.5701 23.0913 22.7858 22.8971C23.0014 22.7029 23.1375 22.4357 23.1679 22.1471L23.9479 13.5629C23.9726 13.2921 23.9406 13.0192 23.854 12.7615C23.7673 12.5038 23.6279 12.2669 23.4446 12.0661C23.2614 11.8653 23.0382 11.7049 22.7895 11.5951C22.5408 11.4854 22.2719 11.4286 22 11.4286ZM22 28.5714C22.4547 28.5714 22.8907 28.3908 23.2122 28.0693C23.5337 27.7478 23.7143 27.3118 23.7143 26.8571C23.7143 26.4025 23.5337 25.9664 23.2122 25.645C22.8907 25.3235 22.4547 25.1429 22 25.1429C21.5453 25.1429 21.1093 25.3235 20.7878 25.645C20.4663 25.9664 20.2857 26.4025 20.2857 26.8571C20.2857 27.3118 20.4663 27.7478 20.7878 28.0693C21.1093 28.3908 21.5453 28.5714 22 28.5714Z",
    fill: "#F0B429"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7868_1932",
    x: 0.2,
    y: 0.2,
    width: 43.6,
    height: 43.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.8006 0 0 0 0 0.253108 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7868_1932"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7868_1932",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.369532e786bb1f7d4c3e742b3d2d1924.svg";
export { ForwardRef as ReactComponent };